import { PlayerSizesTypes } from '../../../../common/store/store.types';
import { flexRowCenterCenter } from '../../../../common/styles/flex';

interface StylesObject {
  voltaxLogoStyle: {
    small: { [key: string]: any };
    medium: { [key: string]: any };
    large: { [key: string]: any };
    extraLarge: { [key: string]: any };
    hide: { [key: string]: any };
  } & any;
  voltaxLogoWrapperStyle: { [key: string]: any };
  iconAndToolTipContainerStyle: { [key: string]: any };
}

const voltaxLogo = {
  display: 'flex',
};

const voltaxLogoWrapper = {
  ...flexRowCenterCenter,
  cursor: 'pointer',
  margin: '0px 8px',
  mediumMobile: {
    ...flexRowCenterCenter,
    height: '40px',
    width: '40px',
    margin: 'unset',
  },
  hide: {
    display: 'none',
  },
};

const iconAndToolTipContainer = {
  position: 'relative',
  display: 'grid',
  hide: {
    display: 'none',
  },
};

export const getVoltaxLogoStyleObject = (playerSize: PlayerSizesTypes, hideVoltaxLogo: boolean, desktopMode: boolean): StylesObject => {
  const smallSize = playerSize === 'small';
  const mediumSize = playerSize === 'medium';

  return ({
    voltaxLogoStyle: [
      voltaxLogo,
    ],
    voltaxLogoWrapperStyle: [
      voltaxLogoWrapper,
      !desktopMode && mediumSize && voltaxLogoWrapper.mediumMobile,
      (hideVoltaxLogo || smallSize) && voltaxLogoWrapper.hide,
    ],
    iconAndToolTipContainerStyle: [
      iconAndToolTipContainer,
      hideVoltaxLogo && iconAndToolTipContainer.hide,
    ],
  });
};
